import React, { useEffect, useReducer } from 'react';

import { useSubscription } from '../../../Emitter';

import * as helpers from './helpers';
import * as actions from './store/actions';
import { reducer, initialState } from './store/reducer';
import { tagTypeService } from 'js/services/tagType.service';

export const Tag = ({ tag }) => {
    const { name, tagTypeId, conditions, config } = tag;
    const tagsByType = tagTypeService.getTagTypes();
    const Component = tagsByType[tagTypeId];
    const [data, dispatch] = useReducer(reducer, initialState);
    const { triggers: [firstTrigger], isRunTag, timestamp } = data;

    /**
     * Receive triggers from application and store them for further processing.
     */
    useSubscription((trigger) => {
        dispatch(actions.addTrigger(trigger));
    });

    /**
     * Iterate over each of the received triggers and check them one by one.
     */
    useEffect(() => {
        if (!firstTrigger) {
            // do not do anything if we do not have a trigger
            return;
        }

        const { regular, additional } = helpers.groupConditions(conditions);

        if (!helpers.canBeTriggered(firstTrigger, regular)) {
            // if this tag does not have condition that was triggered, skip it
            dispatch(actions.skipTrigger());
            return;
        }

        const result = helpers.checkCondition(firstTrigger, regular, additional);

        dispatch(actions.checkTrigger(result));
    }, [firstTrigger, conditions, dispatch, name]);

    return Component && isRunTag
        ? (
            <Component
                tagName={name}
                key={timestamp}
                config={config}
                tagTypeId={tagTypeId}
            />
        )
        : null;
};
